import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isOpen"],
  _excluded2 = ["children", "isVisible", "gap"],
  _excluded3 = ["gap"];
import { Drawer } from 'breeze-intelligence-kit';
import { LayoutSpaceVertical, LayoutHorizontal } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const BasePanel = _ref => {
  let {
      children,
      isOpen = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Drawer, Object.assign({
    isOpen: isOpen
  }, rest, {
    children: children
  }));
};
BasePanel.displayName = 'BasePanel';
function BasePanelHeader(props) {
  return /*#__PURE__*/_jsx(Drawer.Header, Object.assign({}, props));
}
BasePanelHeader.displayName = 'BasePanel.Header';
BasePanel.Header = BasePanelHeader;
function BasePanelHeading(props) {
  return /*#__PURE__*/_jsx(Drawer.Heading, Object.assign({}, props));
}
BasePanelHeading.displayName = 'BasePanel.Heading';
BasePanel.Heading = BasePanelHeading;
function BasePanelBody(props) {
  return /*#__PURE__*/_jsx(Drawer.Body, Object.assign({}, props));
}
BasePanelBody.displayName = 'BasePanel.Body';
BasePanel.Body = BasePanelBody;
function BasePanelContent(props) {
  return /*#__PURE__*/_jsx(Drawer.Content, Object.assign({}, props));
}
BasePanelContent.displayName = 'BasePanel.Content';
BasePanel.Content = BasePanelContent;
const Footer = _ref2 => {
  let {
      children,
      isVisible = true,
      gap = 'space-sm'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/_jsx(Drawer.Footer, {
    children: /*#__PURE__*/_jsx(LayoutSpaceVertical, Object.assign({}, rest, {
      gap: gap,
      children: children
    }))
  });
};
BasePanel.Footer = Footer;
const FooterActions = _ref3 => {
  let {
      gap = 'space'
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/_jsx(LayoutHorizontal, Object.assign({}, rest, {
    gap: gap
  }));
};
BasePanel.FooterActions = FooterActions;